<h5 mat-dialog-title data-testid="login-title">Авторизуйтесь пожалуйста</h5>

<div mat-dialog-content class="pd-1">
    @if (registration) {
        <form [formGroup]="registrationForm" class="flex-column">
            <mat-form-field>
                <mat-label>Login</mat-label>
                <input formControlName="login" matInput>
            </mat-form-field>
            <mat-form-field>
                <mat-label>Пароль</mat-label>
                <input formControlName="password" matInput type="password">
            </mat-form-field>
            <mat-form-field>
                <mat-label>Повторите пароль</mat-label>
                <input formControlName="confirmedPassword" matInput type="password">
            </mat-form-field>
            <button (click)="registerNewUser()" color="primary" mat-raised-button>Зарегистрироваться</button>
        </form>
    } @else {
        <form [formGroup]="registrationForm" class="flex-column">
            <mat-form-field>
                <mat-label>Логин</mat-label>
                <input formControlName="login" matInput data-testid="login-input">
            </mat-form-field>
            <mat-form-field>
                <mat-label>Пароль</mat-label>
                <input formControlName="password" matInput type="password" data-testid="password-input">
            </mat-form-field>
            <button mat-flat-button (click)="logIn()" color="primary" data-testid="login-button">Войти</button>
        </form>
    }
</div>


